import BseRepository from '../../domain/repositories/BseRepository';
import BseDataStore from '../datastores/BseDataStore';
import BseDataStoreFactory from '../factories/BseDataStoreFactory';

export default class BseDataRepository implements BseRepository {
  processBse(idRequest: string, test: boolean) {
    const bseDataStore: BseDataStore = BseDataStoreFactory.create();
    return bseDataStore.processBse(idRequest, test);
  }

  getFormBse(requestId: number) {
    const bseDataStore: BseDataStore = BseDataStoreFactory.create();
    return bseDataStore.getFormBse(requestId);
  }

  registerBse(
    operationNumber: number,
    origin: string,
    fields: any,
    UT: boolean
  ) {
    const scholarshipsBseDataStore: BseDataStore = BseDataStoreFactory.create();
    return scholarshipsBseDataStore.registerBse(
      operationNumber,
      origin,
      fields,
      UT
    );
  }

  getBseDocument(idRequest: number) {
    const store: BseDataStore = BseDataStoreFactory.create();
    return store.getBseDocument(idRequest);
  }

  uploadBseDocument(requestId: number, data: any) {
    const store: BseDataStore = BseDataStoreFactory.create();
    return store.uploadBseDocument(requestId, data);
  }

  deleteFileBse(idFile: number) {
    const scholarshipsBseDataStore: BseDataStore = BseDataStoreFactory.create();
    return scholarshipsBseDataStore.deleteFileBse(idFile);
  }

  activatePayOrder(operationNumber: number, origin: string) {
    const scholarshipsBseDataStore: BseDataStore = BseDataStoreFactory.create();
    return scholarshipsBseDataStore.activatePayOrder(operationNumber, origin);
  }

  getStateBse(idProcedure: number, operationNumber: number) {
    const getStateBse: BseDataStore = BseDataStoreFactory.create();
    return getStateBse.getStateBse(idProcedure, operationNumber);
  }
}
